import { createI18nClient } from '@service-initiation/shared-data-access-i18n';

//todo: add back fallbackURL
export const i18nClient = createI18nClient({
  fallbackTranslationsUrl: 'fallbackTranslationsUrl' as unknown as string,
  namespace: 'store-initiation',
});
